export default function(app) {
  if (process.env.SERVER_BUILD !== 'ssr') {
    // edit-pages
    const EditPages = require('dev/edit-pages')
    const EditPage = () => import(/* webpackChunkName: 'edit-pages' */ 'dev/edit-pages/src/pages/EditPage')
    app.addPlugin(EditPages.default, { lazyStore: true })

    const loadEditPagesStore = function(store) {
      if (!store.hasModule('editPages')) {
        return EditPages.default.store().then(moduleStore => {
          store.registerModule('editPages', moduleStore.default, { preserveState: store.state.editPages !== undefined })
        })
      }
      return Promise.resolve(true)
    }

    app.addRoutes([
      {
        path: '*/edit',
        component: EditPage,
        name: 'Item Edit',
        meta: {
          requiresAuth: 'allow',
          onload: ({ store }) => loadEditPagesStore(store)
        }
      },
      {
        path: '*/create',
        component: EditPage,
        name: 'Item Create',
        meta: {
          requiresAuth: 'allow',
          onload: ({ store }) => loadEditPagesStore(store),
          create: true
        }
      }
    ])
  }
}
